import ServiceDetailBook from "./ServiceDetailBook";
import ServiceDetailFind from "./ServiceDetailFind";
import ServiceDetailGallery from "./ServiceDetailGallery";
import ServiceDetailHead from "./ServiceDetailHead";
import ServiceDetailPerform from "./ServiceDetailPerform";
import ServiceDetailRange from "./ServiceDetailRange";
import ServiceDetailSlide from "./ServiceDetailSlide";
import ServiceDetailStyle from "./ServiceDetailStyle";

export default function ServiceDetail() {

  const imgSlide = [
      { 
        title: 'Style & mood',
        name: 'Wooden Work',
        para: 'Discover our selection of wood-effect surfaces.',
        link: '/project',
        linktext: 'Explore The Collections',
        imageA: '../image/split-img1.webp',
        imageB: '../image/split-img1b.webp',
      },

      { 
        title: 'Style & mood',
        name: 'Glass Elements',
        para: 'Our selection of sleek glass-effect surfaces & furniture.',
        link: '/project',
        linktext: 'Explore The Collections',
        imageA: '../image/split-img2.webp',
        imageB: '../image/split-img2b.webp',
      },

      { 
        title: 'Style & mood',
        name: 'Metal & Fibre Works',
        para: 'Modern designs crafted with metal and fibre textures.',
        link: '/project',
        linktext: 'Explore The Collections',
        imageA: '../image/split-img3.webp',
        imageB: '../image/split-img3b.webp',
      },

      { 
        title: 'Style & mood',
        name: 'Stone Furniture',
        para: 'Elegant, durable pieces that blend natural strength with timeless, sculptural design.',
        link: '/project',
        linktext: 'Explore The Collections',
        imageA: '../image/split-img4.webp',
        imageB: '../image/split-img4b.webp',
      },

      { 
        title: 'Style & mood',
        name: 'PU Paint Finish',
        para: 'A sleek, durable coating that enhances surfaces with lasting shine and refined elegance.',
        link: '/project',
        linktext: 'Explore The Collections',
        imageA: '../image/split-img5.webp',
        imageB: '../image/split-img5b.webp',
      },

      { 
        title: 'Style & mood',
        name: 'solid wood',
        para: 'Tailored dining spaces crafted to reflect your taste, blending elegance with personalized comfort.',
        link: '/project',
        linktext: 'Explore The Collections',
        imageA: '../image/split-img6.webp',
        imageB: '../image/split-img6b.webp',
      },
    ]
    
  return (
    <>
    <ServiceDetailHead/>
    <ServiceDetailFind/>
    <ServiceDetailRange/>
    <ServiceDetailGallery/>
    <ServiceDetailStyle/>
    <ServiceDetailSlide imgSlide={imgSlide}/>
    <ServiceDetailBook/>
    <ServiceDetailPerform/>
    </>
  )
}
